import React from 'react';
import { IconProps } from '.';

const SvgWarehouseReturn = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M3.25 2.25h17.5V13h-1.5v-1.5H4.75v8.75h1.7v-6H12v6h1.3v1.5H3.25V2.25Zm4.7 13.5h2.5v4.5h-2.5v-4.5Zm-3.2-12V10h2V6h4V5h6.5v5h2V3.75H4.75Zm7.5 6.25V6.5h3.5V10h-3.5Zm-4-2.5h2.5V10h-2.5V7.5Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        d='M16.262 15.7h2a2.25 2.25 0 1 1 0 4.5h-1.28l1.29-1.201L17.25 17.9l-3.05 2.84 3.014 3.221 1.095-1.024L17.15 21.7h1.11a3.75 3.75 0 0 0 0-7.5h-2v1.5Z'
      />
    </svg>
  );
};

export default SvgWarehouseReturn;
